/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Next_CtaInputs */

const en_fc_dl_next_cta = /** @type {(inputs: Fc_Dl_Next_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the tutorial`)
};

/**
* | output |
* | --- |
* | "Open the tutorial" |
*
* @param {Fc_Dl_Next_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_next_cta = /** @type {((inputs?: Fc_Dl_Next_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Next_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_next_cta(inputs)
});
export { fc_dl_next_cta as "fc.dl.next.cta" }